import React from 'react';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { customerFacingPriceFormatter } from './utils';
import { getHoliday } from '../common/getHoliday';
import { OrderPageTypography } from './themedComponents/OrderPageTypography';
import { useLanguage } from '../common/GeneralUtils';
import { OrderPageIntent } from './OrderPageIntent';
import { calculatePrice } from './OrderUtils';

type PriceSummaryProps = {
  activeStep: number;
  orderPageIntent: OrderPageIntent;
  orderPageState: any;
  persons: number;
  date: string;
};
export const PriceSummary = ({ activeStep, orderPageIntent, orderPageState, persons, date }: PriceSummaryProps) => {
  const { t } = useTranslation();
  const language = useLanguage();
  const theme = useTheme();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { price } = orderPageState.details;
  const hasMultipleTicketsPricing = !!orderPageState.orderPage.objects.find((x: any) => x.type === 'multipleTickets');

  const shouldShowPriceSummary = activeStep === 0 && orderPageIntent !== OrderPageIntent.REDEEM_GIFT_CARD;

  const depositPrice = orderPageState.account.deposit_percentage
    ? calculatePrice(
        orderPageState.orderPage,
        orderPageState.details,
        orderPageState.dateAndTimeDetails,
        undefined,
        orderPageState.account.deposit_percentage,
      )
    : null;

  return shouldShowPriceSummary ? (
    <Grid container display="flex" flexDirection="column" xs={isSmallScreen ? undefined : 6}>
      {!hasMultipleTicketsPricing && (
        <Grid item gap={1} display="flex" flexDirection="row">
          <OrderPageTypography variant={'h6'} bold>
            {t('order_page.perTicket')}
          </OrderPageTypography>
          <OrderPageTypography variant={'h6'}>
            {customerFacingPriceFormatter(+(price / persons).toFixed(0), orderPageState.account)}
          </OrderPageTypography>
        </Grid>
      )}
      {getHoliday(orderPageState.account.holiday_calendar, date) && (
        <Grid item gap={1} display="flex" flexDirection="row">
          <OrderPageTypography variant={'h6'} bold>
            {getHoliday(orderPageState.account.holiday_calendar, date, language)}
          </OrderPageTypography>
        </Grid>
      )}
      <Grid item gap={1} display="flex" flexDirection="row">
        <OrderPageTypography variant={'h6'} bold>
          {t('order_page.total')}
        </OrderPageTypography>
        <OrderPageTypography variant={'h6'}>
          {customerFacingPriceFormatter(price, orderPageState.account, true)}
        </OrderPageTypography>
      </Grid>
      {depositPrice !== null && (
        <Grid item gap={1} display="flex" flexDirection="row" mb={3}>
          <OrderPageTypography variant={'h6'} bold>
            {t('order_page.deposit')}
          </OrderPageTypography>
          <OrderPageTypography variant={'h6'}>
            {customerFacingPriceFormatter(depositPrice, orderPageState.account, true)}
          </OrderPageTypography>
        </Grid>
      )}
    </Grid>
  ) : null;
};
